import * as R from 'ramda'
import React, { useEffect } from 'react'
import { FormProvider, useForm } from 'react-hook-form'
import { useDispatch, useSelector } from 'react-redux'

import Loading from '../../components/loading'
import { FrontendSetting, FrontendSettingForm } from '../../interfaces/setting'
import {
  getFrontendSettingRequest,
  updateFrontendSettingRequest
} from '../../redux/setting/actions'
import {
  getFrontendSetting,
  getIsFetchingFrontendSetting,
  getIsUpdatingFrontendSetting
} from '../../redux/setting/selectors'
import { updateHomePageSettingFormToApiConvertor } from '../../utils/service'
import SettingFormHandlerBar from './SettingFormHandlerBar'
import SettingFormMainBody from './SettingFormMainBody'

// TODO: refactor component such that it is only home page setting
const SettingForm = () => {
  const dispatch = useDispatch()

  useEffect(() => {
    dispatch(getFrontendSettingRequest())
  }, [])

  const emptyFrontendSetting = {
    inSeasonCategoryIds: [],
    featuredVerifiedCompanyNos: [],
    promoBannerImages: []
  }

  const isFetchingFrontendSetting = useSelector(getIsFetchingFrontendSetting)
  const isUpdatingFrontendSetting = useSelector(getIsUpdatingFrontendSetting)
  const frontendSetting =
    (useSelector(getFrontendSetting) as FrontendSetting) ?? emptyFrontendSetting
  const frontendSettingForm: FrontendSettingForm = {
    ...R.pick(['promoBannerImages', 'bottomPromoBannerImage'], frontendSetting),
    inSeasonCategoryIds: R.join(',', frontendSetting.inSeasonCategoryIds),
    featuredVerifiedCompanyNos: R.join(
      ',',
      frontendSetting.featuredVerifiedCompanyNos
    )
  }

  const methods = useForm<FrontendSettingForm>()

  const formHandlers = {
    updateFrontendSetting: (
      updatedFrontendSetting: FrontendSettingForm
    ): void => {
      dispatch(
        updateFrontendSettingRequest(
          updateHomePageSettingFormToApiConvertor(updatedFrontendSetting)
        )
      )
    }
  }

  const { handleSubmit } = methods

  return (
    <FormProvider {...methods}>
      <form>
        <SettingFormHandlerBar
          saveHandler={handleSubmit(formHandlers.updateFrontendSetting)}
        />
        {isFetchingFrontendSetting || isUpdatingFrontendSetting ? (
          <Loading />
        ) : (
          <SettingFormMainBody frontendSetting={frontendSettingForm} />
        )}
      </form>
    </FormProvider>
  )
}

export default SettingForm
